
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype4Off as ObiMosfetNtype4OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-4-off.js';
 
 
 

 
 export const ObiMosfetNtype4Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-4-off',
   elementClass: ObiMosfetNtype4OffElement,
   events: {
     
   }
  });
 
 